import { Reveal } from "@/components/Reveal";

const IMG_CONCEPT =
  "https://images.unsplash.com/photo-1520399636535-24741e71b160?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxhdGhsZXRpYyUyMHRyYWluaW5nJTIwY29hY2glMjB0ZWFtJTIwaGlnaCUyMGNvbnRyYXN0fGVufDB8fHx8MTc4NzQxNzAwOHww&ixlib=rb-4.1.0&q=85";

const FEATURES = [
  "Strength & conditioning / performance zone",
  "Basketball courts",
  "Indoor turf / multi-sport training",
  "Tennis training",
  "Golf simulation",
  "Cardio & fitness",
  "Nutrition bar / lounge",
  "Recovery / treatment",
  "Mentorship & academic hub",
  "Meeting / education / administrative spaces",
  "Outdoor athletic areas / track as plans permit",
];

export const Campus = () => (
  <section id="campus" className="py-20 sm:py-28 lg:py-36 px-4 sm:px-8 lg:px-16 bg-[#0C0C12] border-y border-[#242436]" data-testid="campus-section">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
      <div>
        <Reveal>
          <span className="inline-block bg-[#FFB800]/15 text-[#FFB800] font-mono text-[10px] font-bold uppercase tracking-widest px-3 py-1 mb-5" data-testid="campus-proposed-badge">
            Future / Proposed
          </span>
          <div className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-[#FFB800] mb-4">G.A.M.E. Training Campus</div>
          <h2 className="font-display font-black uppercase tracking-tight leading-none text-3xl sm:text-4xl lg:text-6xl text-[#F4F4F6]">
            Where athletic excellence <span className="text-[#8B5CF6]">meets academic achievement.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-8 text-sm sm:text-base leading-relaxed text-[#A1A1B3]">
            A comprehensive athletic, academic and wellness destination combining performance
            development with mentorship, education, recovery and community engagement.
          </p>
          <p className="mt-4 font-mono text-xs uppercase tracking-[0.15em] text-[#62627A] leading-relaxed">
            Presented as the proposed G.A.M.E. Training Campus until a facility is acquired, financed,
            constructed and operational. Commercial campus operations will be run by G.A.M.E. Training LLC.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4" data-testid="campus-features">
            {FEATURES.map((f, i) => (
              <div key={f} className="flex items-start gap-3">
                <span className="font-mono text-xs tracking-[0.2em] text-[#FFB800] shrink-0 pt-0.5">{String(i + 1).padStart(2, "0")}</span>
                <span className="text-sm text-[#A1A1B3] leading-relaxed">{f}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.1} className="relative lg:sticky lg:top-24">
        <div className="clip-frame relative overflow-hidden border border-[#242436]" data-testid="campus-concept-frame">
          <img src={IMG_CONCEPT} alt="Conceptual rendering of athletic training at the proposed G.A.M.E. Training Campus" className="w-full h-[420px] sm:h-[540px] object-cover opacity-80" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#08080C] via-transparent to-transparent" />
          <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse 60% 50% at 50% 30%, rgba(139,92,246,0.18), transparent 60%)" }} />
          <div className="absolute bottom-5 left-5 bg-[#FFB800] text-black font-mono font-bold px-3 py-1 text-xs uppercase tracking-widest">
            Conceptual Rendering · Proposed Campus Vision
          </div>
        </div>
        <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-[#FFB800] pointer-events-none" />
        <p className="mt-10 border-l-2 border-[#8B5CF6] pl-6 font-display font-bold uppercase text-xl sm:text-2xl leading-snug text-[#F4F4F6]">
          Built by tenacity. Earned, not given — what you do daily defines you.
        </p>
      </Reveal>
    </div>
  </section>
);
